import React, { useState, useEffect } from 'react';
import { Container, Tabs, Tab, Paper, Typography, Box, CardContent, Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../contexts/AuthContext';
import ProfileTab from '../components/account/ProfileTab';
import SecurityTab from '../components/account/SecurityTab';
import CalendarSubscriptionTab from '../components/account/CalendarSubscriptionTab';
import CustomDataTab from '../components/account/CustomDataTab';
import { useBusinessTheme } from '../contexts/BusinessThemeContext';

const MyAccount: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { theme } = useBusinessTheme();
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <>
      <Helmet>
        <title>My Account | MindShare Calendar</title>
      </Helmet>
      <Container maxWidth="md" sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 4 } }}>
        <Card sx={{ backgroundColor: theme.accentColor }}>
          <CardContent>

            <Typography variant="h4" component="h1" gutterBottom>
              My Account
            </Typography>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
              <Tabs value={currentTab} onChange={handleTabChange}>
                <Tab label="Profile" />
                <Tab label="Security" />
                <Tab label="Calendar" />
                <Tab label="User Data" />
              </Tabs>
            </Box>

            {currentTab === 0 && <ProfileTab />}
            {currentTab === 1 && <SecurityTab />}
            {currentTab === 2 && <CalendarSubscriptionTab />}
            {currentTab === 3 && <CustomDataTab />}
          </CardContent>
        </Card>
      </Container>
    </>
  );
};

export default MyAccount; 